import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";

const WareHouseListComponent = loadable(
  () => import("../../components/Warehouse/WarehouseList")
);

const WareHouseList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Warehouse</span>
      </div>
      <WareHouseListComponent />
    </>
  );
};

export default WareHouseList;
